import { render, staticRenderFns } from "./AmexIcon.vue?vue&type=template&id=09a81833&"
import script from "./AmexIcon.vue?vue&type=script&lang=js&"
export * from "./AmexIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports